<div class="container p-2">
  <div class="mat-dialog-content">
    <span>{{ message }}</span>
  </div>
  <div class="flex_container">
    <button class="ex1" (click)="decisionClick('yes')">Yes</button>
    <button class="ex2" (click)="decisionClick('no')">No</button>
  </div>
</div>
